export default __webpack_public_path__ + "static/google-customer-reviews-a39ab8bdde1028a0ce6cd29b0d1967c4.png";